import { useFormCustomComponentSubmitFormAnswersMutation } from '@graphql/generated';
import { useToast } from '@withjoy/joykit';
import { useQueryParamHelper } from '@shared/core/queryString';

export const useSubmitFormAnswers = () => {
  const [mutation] = useFormCustomComponentSubmitFormAnswersMutation();
  const { getValueString } = useQueryParamHelper();
  const guestKey = getValueString('guestKey');

  const { toast } = useToast();

  const submitFormAnswers = async (formId: string, answers: Record<string, unknown>) => {
    const formattedAnswers = Object.entries(answers).map(([questionId, answerValue]) => ({
      questionId,
      // `as string` cast is less than ideal
      // but is what is done everywhere else we use the survey component.
      // FormService currently expects everything to be a string.
      // And the Survey component only returns string answers.
      answerValue: answerValue as string,
    }));

    const { data, errors } = await mutation({
      variables: {
        input: {
          answers: formattedAnswers,
          formId,
          guestKey,
        },
      },
    });

    if (errors || !data?.submitFormAnswers) {
      toast('Error submitting form response');
      return null;
    }

    return data.submitFormAnswers;
  };

  return { submitFormAnswers };
};
